import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-hover"]

import {
		ref
	} from 'vue'
	
	const __default__ = { name: 'VTextLink' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	const hovered = ref(false)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    onMouseover: _cache[0] || (_cache[0] = ($event: any) => (hovered.value = true)),
    onMouseout: _cache[1] || (_cache[1] = ($event: any) => (hovered.value = false)),
    "data-hover": hovered.value ? true : null,
    class: "text-zinc-950 underline decoration-zinc-950/50 data-[hover]:decoration-zinc-950 dark:text-white dark:decoration-white/50 dark:data-[hover]:decoration-white cursor-pointer"
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 40, _hoisted_1))
}
}

})